import { defineStore } from 'pinia'
import axios from 'axios'

export const useTaskDetailDialogStore = defineStore('taskDetailDialog', {
  state: () => ({
    open: false,
    loading: false,
    detail: null,
    task: null,
    error: '',
  }),
  actions: {
    closeDialog() {
      this.open = false
    },
    async openTaskDetail(task, sysObject) {
      if (!task?.id) {
        return
      }

      this.open = true
      this.loading = true
      this.detail = null
      this.error = ''
      this.task = task

      const params = {
        key: sysObject?.key,
        dealId: sysObject?.dealId || sysObject?.deal,
        taskId: task.id,
        subDomain: sysObject?.subDomain,
      }

      if (!params.key || !params.dealId || !params.subDomain) {
        this.error = 'Не удалось получить параметры запроса из sysObject.'
        this.loading = false
        return
      }

      try {
        const res = await axios.get('/api/taskDetail', { params })
        this.detail = res.data
        if (!res.data?.success) {
          this.error = res.data?.errorMessage || 'Ошибка получения деталей задачи.'
        }
      } catch (error) {
        this.error = error?.message || 'Ошибка запроса taskDetail.'
        console.error('[taskDetail] request failed', error)
      } finally {
        this.loading = false
      }
    },
  },
})
